import { createContext } from 'react';

import { app, firebase } from './firebase';

export const FirebaseContext = createContext({
  firebase,
  auth: app.auth(),
  db: app.database(),
});
